import type { ComponentProps, ReactNode } from 'react'
import { cn } from '@joyful/utils'

export interface AppShellProps extends ComponentProps<'div'> {
  children: ReactNode
}

export function AppShell({ children, className, ...props }: AppShellProps) {
  return (
    <div
      className={cn(
        'bg-tremor-background flex h-svh min-h-0 w-full flex-col',
        className,
      )}
      {...props}
    >
      {children}
    </div>
  )
}

export function AppShellBody({
  children,
  className,
  ...props
}: ComponentProps<'div'>) {
  return (
    <div className={cn('flex min-h-0 flex-1', className)} {...props}>
      {children}
    </div>
  )
}

export function AppShellSidePanel({
  children,
  className,
  ...props
}: ComponentProps<'div'>) {
  return (
    <div
      className={cn(
        'border-tremor-border bg-tremor-background shrink-0 border-r',
        className,
      )}
      {...props}
    >
      {children}
    </div>
  )
}

export function AppShellContent({
  children,
  className,
  ...props
}: ComponentProps<'div'>) {
  return (
    <div
      className={cn(
        'bg-tremor-background flex min-w-0 flex-1 flex-col overflow-y-auto',
        className,
      )}
      {...props}
    >
      {children}
    </div>
  )
}
